import React from "react"
import { Link } from "gatsby"

import Layout from "../components/Layout";
import SEO from "../components/Seo";

import styled from "@emotion/styled";
import tw from "twin.macro";

import { GlobalStyles } from "twin.macro";

const Container = styled.div`
  ${tw`container mx-auto px-8 py-16`}
`;

const PoliticadePrivacidadePage = () => (
  <Layout>
    <SEO title="Política de Privacidade" />
    <GlobalStyles />

    <Container>
        <p><strong>Este aplicativo é mantido e operado por Márcio Dias - Soluções Digitais</strong></p>
        <br />
        <p>Nós coletamos e utilizamos alguns dados pessoais que pertencem àqueles que utilizam nosso aplicativo. Ao fazê-lo, agimos na qualidade de <strong>controlador</strong> desses dados e estamos sujeitos às disposições da Lei Federal n. 13.709/2018 (Lei Geral de Proteção de Dados Pessoais - LGPD).</p>
        <br />
        <p>Nós cuidamos da proteção de seus dados pessoais e, por isso, disponibilizamos esta política de privacidade, que contém informações importantes sobre:</p>
        <br />
        <p>- Quem deve utilizar nosso aplicativo<br />- Quais dados coletamos e o que fazemos com eles;<br />- Seus direitos em relação aos seus dados pessoais; e<br />- Como entrar em contato conosco.</p>
        <br />
        <p><strong>1. - Dados que coletamos e motivos da coleta.</strong></p>
        <br />
        <p>Nosso aplicativo coleta e utiliza alguns dados pessoais de nossos usuários, de acordo com o disposto nesta seção.</p>
        <br />
        <p><em>1. Dados pessoais fornecidos expressamente pelo usuário</em></p>
        <br />
        <p>Nós coletamos os seguintes dados pessoais que nossos usuários nos fornecem expressamente ao utilizar nosso aplicativo:</p>
        <br />
        <p>
            - Endereço de e-mail
            <br />
            - Nome completo
            <br />
            - Telefone
            <br />
            - Documento de identidade
            <br />
            - Foto
        </p>
        <br />
        <p>A coleta destes dados ocorre nos seguintes momentos:</p>
        <br />
        <p>- Cadastro e aprovação do usuário por alguma loja da rede Mosaic Club</p>
        <br />
        <p>Os dados fornecidos por nossos usuários são coletados com as seguintes finalidades:</p>
        <br />
        <p>O usuário precisa passar por uma análise e comprovar que trabalha como Arquiteto ou Design de Interiores e ganhar prêmios dentro do aplicativo.</p>
        <br />
        <p><strong>2. - Dados sensíveis.</strong></p>
        <br />
        <p><strong>Não</strong> serão coletados dados sensíveis de nossos usuários, assim entendidos aqueles definidos nos arts. 11 e seguintes da Lei de Proteção de Dados Pessoais. Assim, <strong>não</strong> haverá coleta de dados sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural.</p>
        <br />
        <p><em>3. Coleta de dados não previstos expressamente</em></p>
        <br />
        <p>Eventualmente, outros tipos de dados não previstos expressamente nesta Política de Privacidade poderão ser coletados, desde que sejam fornecidos com o consentimento do usuário, ou, ainda, que a coleta seja permitida com fundamento em outra base legal prevista em lei.</p>
        <br />
        <p>Em qualquer caso, a coleta de dados e as atividades de tratamento dela decorrentes serão informadas aos usuários do aplicativo.</p>
        <br />
        <p><strong>2. Compartilhamento de dados pessoais com terceiros</strong></p>
        <br />
        <p>Nós não compartilhamos seus dados pessoais com terceiros. Apesar disso, é possível que o façamos para cumprir alguma determinação legal ou regulatória, ou, ainda, para cumprir alguma ordem expedida por autoridade pública.</p>
        <br />
        <p><strong>3. Por quanto tempo seus dados pessoais serão armazenados</strong></p>
        <br />
        <p>Os dados pessoais coletados pelo aplicativo são armazenados e utilizados por período de tempo que corresponda ao necessário para atingir as finalidades elencadas neste documento e que considere os direitos de seus titulares, os direitos do controlador do aplicativo e as disposições legais ou regulatórias aplicáveis.</p>
        <br />
        <p>Uma vez expirados os períodos de armazenamento dos dados pessoais, eles são removidos de nossas bases de dados ou anonimizados, salvo nos casos em que houver a possibilidade ou a necessidade de armazenamento em virtude de disposição legal ou regulatória.</p>
        <br />
        <p>Bases legais para o tratamento de dados pessoais</p>
        <br />
        <p>Uma base legal para o tratamento de dados pessoais nada mais é que um fundamento jurídico, previsto em lei, que justifica o justifica. Assim, cada operação de tratamento de dados pessoais precisa ter uma base legal a ela correspondente.</p>
        
        <br />
        <p>Nós tratamos os dados pessoais de nossos usuários nas seguintes hipóteses:</p>
        
        <br />
        <p>- quando necessário para atender aos interesses legítimos do controlador ou de terceiro</p>
        
        <br />
        <p><em>1. Legítimo interesse</em></p>
        
        <br />
        <p>Para determinadas operações de tratamento de dados pessoais, nos baseamos exclusivamente em nosso interesse legítimo. Para saber mais sobre em quais casos, especificamente, nos valemos desta base legal, ou para obter mais informações sobre os testes que fazemos para termos certeza de que podemos utilizá-la, entre em contato com nosso Encarregado de Proteção de Dados Pessoais por algum dos canais informados nesta Política de Privacidade, na seção "Como entrar em contato conosco".</p>

        <br />
        <p><em>1. Como o titular pode exercer seus direitos</em></p>
        
        <br />
        <p>Para garantir que o usuário que pretende exercer seus direitos é, de fato, o titular dos dados pessoais objeto da requisição, poderemos solicitar documentos ou outras informações que possam auxiliar em sua correta identificação, a fim de resguardar nossos direitos e os direitos de terceiros. Isto somente será feito, porém, se for absolutamente necessário, e o requerente receberá todas as informações relacionadas.</p>
        
        <br />
        <p>Para esclarecer quaisquer dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que tratamos, entre em contato com nosso Encarregado de Proteção de Dados Pessoais, por algum dos canais mencionados abaixo:</p>
        
        <br />
        <p><strong>Endereço de e-mail:</strong> contato@marciodias.me</p>
        <p><strong>Telefone:</strong> +55 (37) 3212-8406</p>
        <p><strong>Endereço postal:</strong> Rua Monte Santo 545 sala 03 - Divinópolis / MG</p>
    </Container>
  </Layout>
)

export default PoliticadePrivacidadePage;